export default __webpack_public_path__ + "static/media/download.92ecc015.svg";